import Head from 'next/head'
import {useRouter} from 'next/router'
import {useEffect} from 'react'

import Layout from '@/components/Layout.js'
import RequestInfoModal from '@/components/RequestInfoModal.js'
import utilityStyles from '@/styles/UtilityPage.module.scss'
import {allSites} from '@/utils/domains.js'

export const getStaticPaths = async () => {
  return {
    paths: allSites.map(site => ({
      params: {site},
    })),
    fallback: false,
  }
}

export async function getStaticProps({params}) {
  return {
    props: {site: params.site},
  }
}

function RequestInfo({site}) {
  const router = useRouter()

  useEffect(() => {
    router.prefetch('/')
  }, [router])

  return (
    <Layout site={site} headerDisabled footerDisabled>
      <div id="wrapper">
        <Head>
          <meta name="robots" content="noindex" />
          <title>Request Info | Campus</title>
          <link rel="canonical" href="https://campus.edu/request-info" />
          <meta
            name="description"
            content="Provide your information and an admissions counselor will be in touch shortly (typically within 24 hours)."
          />
        </Head>
        <h1 className={utilityStyles['visually-hidden']}>
          Connect with Admissions
        </h1>
        <RequestInfoModal site={site} close={() => router.push('/')} />
      </div>
    </Layout>
  )
}

export default RequestInfo
